import { render, staticRenderFns } from "./LedesForm.vue?vue&type=template&id=6ef16556&"
import script from "./LedesForm.vue?vue&type=script&lang=js&"
export * from "./LedesForm.vue?vue&type=script&lang=js&"
import style0 from "./LedesForm.vue?vue&type=style&index=0&id=6ef16556&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports